














































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "../lib/ajax";
@Component({
    components: {}
})
export default class ChangePassword extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    spinShow:boolean = false;
    viewModel = {
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: ""
    };

    async save() {
        (this.$refs.changePwdForm as any).validate(async (valid: boolean) => {
            if (valid) {
                try {
                    this.spinShow = true;
                    await Ajax.post('/api/services/app/User/ChangePassword',this.viewModel);
                    //this.spinShow = false;
                    this.$Message.success(this.L('UpdateSuccessMessage',undefined,this.L('Password')));
                    (this.$refs.changePwdForm as any).resetFields();
                    this.$emit("input", false);
                }  finally {
                    this.spinShow = false;
                }
            }
        });
    }
    cancel() {
        (this.$refs.changePwdForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        }
    }
    validatePassCheck = (rule: any, value: any, callback: any) => {
        if (value !== this.viewModel.newPassword) {
            callback(new Error(this.L("ConfirmPasswordNotMatch")));
        } else {
            callback();
        }
    };
    rules = {
        currentPassword: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("CurrentPassword")
                ),
                trigger: "blur"
            }
        ],
        newPassword: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("NewPassword")
                ),
                trigger: "blur"
            }
        ],
        confirmNewPassword: [
            {
                required: true,
                message:this.L('FieldIsRequired',undefined,this.L('ConfirmPassword')),
                trigger: "blur"
            },
            {
                validator: this.validatePassCheck,
                trigger: "blur"
            }
        ]
    };
}
